module.exports = __webpack_public_path__ + "static/img/progress_icon3.c61144dc.svg";